import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const BellIcon = ({
  color = 'black80',
  width = 22,
  marginLeft,
  marginRight,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9V12.2784C16 12.454 16.0462 12.6264 16.134 12.7784L17.7053 15.5C18.0902 16.1667 17.6091 17 16.8393 17H16H13.0287H8.97131H6H5.16079C4.39099 17 3.90987 16.1667 4.29477 15.5L5.86603 12.7785C5.95379 12.6265 6 12.454 6 12.2785V9C6 6.23858 8.23858 4 11 4C13.7614 4 16 6.23858 16 9Z"
        fill={getSemanticTextColor(color)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 18C8 18 8 18 8 18C8 19.6569 9.34315 21 11 21C12.6569 21 14 19.6569 14 18C14 18 14 18 14 18L8 18Z"
        fill={getSemanticTextColor(color)}
      />
      <circle cx="11" cy="3" r="2" fill={getSemanticTextColor(color)} />
      <rect x="9" y="3" width="4" height="2" fill={getSemanticTextColor(color)} />
    </svg>
  </DefaultIconWrapper>
);
